import logo from 'assets/images/logo-vertical.svg';
import logoHorizontal from 'assets/images/logo-horizontal.svg';

import React from 'react';
import { Link } from 'react-router-dom';

export type LogoProps = {
	size?: number;
	isHorizontal?: boolean;
};

const Logo: React.FC<LogoProps> = ({ size = 80, isHorizontal = false }) => {
	return (
		<Link to='/'>
			<img
				src={isHorizontal ? logoHorizontal : logo}
				alt='arabius'
				width={size.toString()}
			/>
		</Link>
	);
};

export default Logo;
